app.controller('CIF2-CTRL', ['$scope','$rootScope','$http', '$window', '$q', '$filter', 'appFactory',
    function ($scope,$rootScope,$http, $window, $q, $filter, appFactory) {

    $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
    $scope.rdnbca = $scope.listBankRDN[0];
    $scope.bankRDN = '';
    $scope.PhoneCode = '+62';
    $scope.CIFInvestor = {}
    $scope.bankpribadi = '';
    $scope.SpouseKewarganegaraan = 'WNI / Indonesian';
    $scope.SpouseKewarganegaraanOption = ['WNI / Indonesian', 'Lainnya / Others'];
    $scope.chkSpouseSeumurHidup = true;
    $scope.disabledNPWPNumber = false;

    let tmpdate = new Date();
    tmpdate.setFullYear(tmpdate.getFullYear() - 17);
    $scope.maxDate = tmpdate.toISOString().slice(0, 10);

    $scope.OPBBCA = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.OPBOTHER = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.OPSPOUSE = {
        occupation: '',
        occupationText: '',
        position: '',
        business: '',
    }

    $scope.IDCardCitySelectedBO = '';

    $scope.chkSeumurHidupBO = true;
    $scope.DisabledSeumurHidupBO = true;
    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiryDate = new Date(9998, 11, 31);

    $scope.disableBank = true;
    $scope.disableCIFInvestorQuestionRDN = false;

    $scope.selectedFundSource = [];
    $scope.selectedSpouseFundSource = [];
    $scope.selectedFundSourceBO = [];
    $scope.CompanyCityBOSelected = '';

    $scope.ListBank = {};
    $scope.listpekerjaan_BCA = {};
    $scope.listjabatan_BCA = {};
    $scope.listusaha_BCA = {};
    $scope.ListLookup = [];
    $scope.ListOccupation = [];
    $scope.ListSpouseIncome = [];

    $scope.CompanyCitySelected = '';
    $scope.SpouseCompanyCitySelected = '';
    $scope.mustSelectBO = function (event, field) {

        if (event.keyCode == 27) {

            let returnValue = true;
            switch (field) {

                case 'CompanyCity': $scope.CIFInvestor.CompanyCity = ''; returnValue = false;
                    break;
                case 'IDCardBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = ''; returnValue = false;
                    break;
                case 'CompanyBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }

    $scope.$watch('OPBBCA.occupation.key', function (newVal, oldVal) {
        if (newVal === oldVal) return;

        if (newVal == '1' || newVal == '2') {
            // "Diri Sendiri" jadi disabled -> kalau user sebelumnya pilih itu, reset (bukan paksa ke Perwakilan)
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwner == 1) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = '';
            }
        } else {
            // "Perwakilan/Pihak Lain" jadi disabled -> kalau user sebelumnya pilih itu, reset (bukan paksa ke Diri Sendiri)
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwner == 2) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = '';
            }
        }
    });

    $scope.selectCity = function (item, model, label, event) {

        if (item.CIFProvinceCityNID) {

            $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
            $scope.CIFInvestor.CompanyCity = item.CIFProvinceCityNID;
        }
    };

    $scope.selectSpouseNationality = function (item, model, label, event) {
        if (item.CIFCountryNID) {

            $scope.CIFInvestor.SpouseNationality = item.CIFCountryNID;
            $scope.SpouseNationalitySelected = item;
        }
    };

    $scope.SpouseKewarganegaraanChange = function () {

        if ($scope.SpouseKewarganegaraan == 'WNI / Indonesian' && $scope.spouseMandatory) {

            $scope.IDLength = 16;
            $scope.chkSpouseSeumurHidup = true;
            $scope.SpouseDisabledSeumurHidup = true;
            $scope.CIFInvestor.SpouseNationality = 102;
            $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(9998, 11, 31);
        }
        else if ($scope.SpouseKewarganegaraan == 'Lainnya / Others') {

            $scope.IDLength = 8;
            $scope.chkSpouseSeumurHidup = false;
            $scope.SpouseDisabledSeumurHidup = true;
            $scope.CIFInvestor.SpouseNationality = 0;
            $scope.CIFInvestor.SpouseIDCardExpiredDate = '';
        }
    }

    $scope.selectIDCardCityBO = function (item, model, label, event) {
        $scope.ListKecamatanBO = '';
        $scope.ListKelurahanBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanBO = data.data.d;
                $scope.kecamatanChangeBO();
            }, function (error) { });

        }

    };

    $scope.selectIDCardCityBenefOther = function (item, model, label, event) {
        $scope.ListKecamatanDomicileBO = '';
        $scope.ListKelurahanDomicileBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOtherCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanDomicileBO = data.data.d;
                $scope.kecamatanDomicileBenefChange();
            }, function (error) { });

        }

    };

    $scope.selectCompanyCityBO = function (item, model, label, event) {
        $scope.ListKecamatanCompanyBO = '';
        $scope.ListKelurahanCompanyBO = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = item.CIFProvinceCityNID;
            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanCompanyBO = data.data.d;
                $scope.kecamatanChangeCompanyCityBO();
            }, function (error) { });
        }

    };


    $scope.questionRDNchange = function () {

        $scope.OPBBCA.occupation = '';
        $scope.OPBBCA.occupationText = '';
        $scope.OPBBCA.position = '';
        $scope.OPBBCA.positionText = '';
        $scope.OPBBCA.business = '';
        $scope.OPBBCA.businessText = '';

        $scope.OPBOTHER.occupation = '';
        $scope.OPBOTHER.occupationText = '';
        $scope.OPBOTHER.position = '';
        $scope.OPBOTHER.positionText = '';
        $scope.OPBOTHER.business = '';
        $scope.OPBOTHER.businessText = '';

        $scope.CIFInvestor.BankName = "";
        $scope.disableBank = false;

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

            $scope.bankpribadi = "BANK CENTRAL ASIA";
            $scope.disableBank = true;
        }
    };

    $scope.changeSpouseMandatory = function (param) {

        if (param) {

            $scope.spouseMandatory = true;
        } else {
            let flag = false;

            if ($scope.OPBBCA) {

                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false
                }
            }

            if ($scope.OPBOTHER) {

                if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

            }

            if ($scope.selectedFundSource.indexOf(7) > -1) {

                flag = true;
                $scope.spouseMandatory2 = true;
                $scope.spouseMandatory1 = false;
            }

            if ($scope.selectedFundSource.indexOf(6) > -1) {

                flag = true;
                $scope.spouseMandatory1 = true;
                $scope.spouseMandatory2 = false;
            }

            if (!flag) {

                $scope.CIFInvestor.SpouseCompanyName = '';
                $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                $scope.CIFInvestor.SpouseOccupation = '';
                $scope.CIFInvestor.SpousePosition = '';
                $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                $scope.CIFInvestor.SpouseCompanyCity = '';
                $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                $scope.CIFInvestor.SpouseCompanyAddress = '';
                $scope.CIFInvestor.SpouseFundSource = '';
                $scope.CIFInvestor.SpouseOccupationText = '';

                $scope.SpouseCompanyCitySelected = '';
                $scope.selectedSpouseFundSource = [];

                $scope.OPSPOUSE.occupation = '';
                $scope.OPSPOUSE.occupationText = '';
                $scope.OPSPOUSE.position = '';
                $scope.OPSPOUSE.business = '';
            }

            $scope.spouseMandatory = flag;
        }
    }

    $scope.NPWPNumber = function () {
        if ($scope.CIFInvestor.QuestionNPWP == 1) {
            $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.IDCardNumber
            $scope.disabledNPWPNumber = true;
        }
    };

    $scope.updateNPWP = function () {

        if ($scope.CIFInvestor.NPWPNumber) {

            if (+$scope.QuestionNPWP == 1) {

                $scope.CIFInvestor.NPWPNumber;
            } else {

                $scope.CIFInvestor.NPWPReason;
                $scope.CIFInvestor.NPWPNumber = '';
            }
        }
    };

    $scope.occupationChange_BCA = function () {

        if ($scope.OPBBCA.occupation) {

            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = 0;
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = 0;
            $scope.OPBBCA.businessText = '';

            if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                $scope.changeSpouseMandatory(true);
            else
                $scope.changeSpouseMandatory();

            appFactory.getData(`service/client.svc/GetJabatan?Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                if (data.status == 200) {

                    $scope.listjabatan_BCA = data.data.d;

                    if ($scope.listjabatan_BCA.length) {
                        $scope.OPBBCA.positionText = '';
                        $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                        $scope.positionChange_BCA();
                    }
                }
            });
        }
    };

    $scope.positionChange_BCA = function () {

        appFactory.getData(`service/client.svc/GetBidangUsaha?Jabatan=${$scope.OPBBCA.position.key}&Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

            if (data.status == 200) {

                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {

                    $scope.OPBBCA.businessText = '';
                    $scope.OPBBCA.business = $scope.listusaha_BCA[0];
                }
            }
        });
    };

    $scope.occupationChange_OTHER = function () {

        if ($scope.OPBOTHER.occupation) {

            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';

            if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
                $scope.changeSpouseMandatory(true);
            else
                $scope.changeSpouseMandatory();
        }
    }

    $scope.toggleFundSourceItem = function (fundsource) {

        let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.FundSourceText = '';

        $scope.changeSpouseMandatory();
    }

    $scope.toggleSpouseFundSourceItem = function (fundsource) {

        $scope.CIFInvestor.SpouseFundSource = '';
        let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedSpouseFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.SpouseFundSourceText = '';
    }

    $scope.toggleFundSourceBOItem = function (fundsource) {
        let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSourceBO.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSourceBO.indexOf(1) < 0)
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSourceText = '';

    }

    $scope.prepareData = function () {

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
            $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
            $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
            $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
            $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
            $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
        } else {

            $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
            $scope.CIFInvestor.Position = 0;
            $scope.CIFInvestor.NatureOfBusiness = 0;

            if ($scope.OPBOTHER.occupation == '4') {

                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusinessText = '';
            } else {

                $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
                $scope.CIFInvestor.NatureOfBusiness = 0;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
            }
        }

        if ($scope.spouseMandatory) {

            $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
            $scope.CIFInvestor.SpouseOccupationText = $scope.OPSPOUSE.occupationText;
            $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
            $scope.CIFInvestor.SpouseNatureOfBusiness = ($scope.OPSPOUSE.business);
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 2;
            //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
        } else {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 1;
            $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
            $scope.CIFInvestor.SpouseOccupation = 0;
            $scope.CIFInvestor.SpouseCompanyCity = 0;
        }

        if ($scope.selectedFundSource) {

            $scope.CIFInvestor.FundSource = '';

            for (var i = 0; i < $scope.selectedFundSource.length; i++) {

                if ($scope.CIFInvestor.FundSource.length > 0)
                    $scope.CIFInvestor.FundSource += ',';
                $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];
            }
        }


        if ($scope.selectedSpouseFundSource) {

            $scope.CIFInvestor.SpouseFundSource = '';

            for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {

                if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                    $scope.CIFInvestor.SpouseFundSource += ',';
                $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];
            }
        }

        if ($scope.selectedFundSourceBO) {
            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = '';
            for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.length > 0)
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += ',';
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += $scope.selectedFundSourceBO[i];

            }
        }
    };



    $scope.validationinput = function () {

        if ($scope.CIFInvestor.BankCabang  != null                         //Data Bank & Pekerjaan
            && $scope.CIFInvestor.QuestionNPWP != null
            && $scope.CIFInvestor.NPWPNumber != null
            && $scope.CIFInvestor.NPWPReason != null
            && $scope.OPBBCA.occupation != null
            && $scope.OPBBCA.positionText != null
            && $scope.OPBBCA.businessText != null
            && ($scope.CIFInvestor.CompanyName != null || $scope.CIFInvestor.CompanyName != "")
            && $scope.CIFInvestor.CompanyAddress != null
            && $scope.CompanyCitySelected != null
            && $scope.CIFInvestor.CompanyPostalCode != null
            && $scope.FundSource != null
            && $scope.CIFInvestor.IncomePerAnnum != null
            && $scope.CIFInvestor.ContactPersonName != null         //Kontak Darurat
            && $scope.CIFInvestor.ContactPersonRelationn != null
            && $scope.CIFInvestor.ContactPersonMobilePhone != null
            && $scope.CIFInvestor.SpouseCompanyName != null         //Jika memilih sumber penghasilan dari ortu
            && $scope.CIFInvestor.SpouseIncomePerAnnum != null
            && $scope.OPSPOUSE.occupation != null
            && $scope.OPSPOUSE.position != null
            && $scope.SpouseCompanyCitySelected != null
            && $scope.CIFInvestor.SpouseCompanyPostalCode != null
            && $scope.CIFInvestor.SpouseCompanyAddress != null
            && $scope.SpouseFundSource.selected != null
            && $scope.CIFInvestor.SpouseFundSourceText != null)
        {
            console.log('validation success');
        }
        else {
            var SWALtranslate = $scope.SWALtranslate('validationinput');

            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }
    }

    var allPromise = $q.all([

          appFactory.getData(`service/client.svc/GetCIFCountry`).then(function (data) {

              if (data.status == 200) {

                  $scope.ListNationality = data.data.d;
              }
          }),

        appFactory.getData(`service/client.svc/GetCIFProvinceCity`).then(function (data) {

            if (data.status == 200) {

                $scope.ListProvinceCity = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetCIFLookup`).then(function (data) {

            if (data.status == 200) {

                $scope.ListLookup = data.data.d;

                if ($scope.ListLookup) {

                    $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListMaritalBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                    $scope.ListEducationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                    $scope.ListAssetsValue = $filter('filter')($scope.ListLookup, { CIFLookupID: 'NetWorth' }, true);
                    $scope.ListOccupationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListFundSourceBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListInvestmentBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
                }
            }
        }),

        appFactory.getData(`service/client.svc/GetCIFBank`).then(function (data) {

            if (data.status == 200) {

                $scope.ListBank = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetCIFPekerjaan`).then(function (data) {

            if (data.status == 200) {

                $scope.listpekerjaan_BCA = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetJabatan`).then(function (data) {

            if (data.status == 200) {

                $scope.listposition_BCA = data.data.d;
            }
        }),

        appFactory.getData(`service/client.svc/GetBidangUsaha`).then(function (data) {

            if (data.status == 200) {

                $scope.listnature_BCA = data.data.d;
            }
        })
    ]);

    allPromise.then(function () {

        appFactory.getData(`service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 2;
                    if ($scope.CIFInvestor.QuestionRDN == 0) {

                        $scope.CIFInvestor.QuestionRDN = '';
                    }

                    if ($scope.CIFInvestor.BankOwner == '' || !$scope.CIFInvestor.BankOwner)
                        $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;

                    $scope.bankpribadi = $scope.CIFInvestor.BankName;

                    if ($scope.CIFInvestor.SpouseCompanyCity)
                        $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                    if ($scope.CIFInvestor.CompanyCity)
                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CompanyCity }, true)[0];
                    console.log('CompanyCitySelected ', $scope.CompanyCitySelected)

                    
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity)
                        $scope.IDCardCitySelectedBO = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity }, true)[0];

                    console.log('IDCardCitySelectedBO ', $scope.IDCardCitySelectedBO)


                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity)
                        $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity }, true)[0];


                    if (data.data.d.SpouseIDCardExpiredDate)
                        $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(data.data.d.SpouseIDCardExpiredDate);

                    if (data.data.d.SpouseBirthDate)
                        $scope.CIFInvestor.SpouseBirthDate = new Date(data.data.d.SpouseBirthDate);

                    if ($scope.CIFInvestor.QuestionRDN) {

                        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                            $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];

                                appFactory.getData(`service/client.svc/GetJabatan?Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                                    if (data.status == 200) {

                                        $scope.listjabatan_BCA = data.data.d;

                                        if ($scope.listjabatan_BCA.length) {

                                            if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                                $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];

                                                appFactory.getData(`service/client.svc/GetBidangUsaha?Jabatan=${$scope.OPBBCA.position.key}&Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                                                    if (data.status == 200) {

                                                        $scope.listusaha_BCA = data.data.d;

                                                        if ($scope.listusaha_BCA.length) {

                                                            if ($scope.CIFInvestor.NatureOfBusiness != null)
                                                                $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    }
                                })
                            }
                        } else {

                            $scope.OPBOTHER.occupation = $scope.CIFInvestor.Occupation;
                            $scope.OPBOTHER.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBOTHER.position = $scope.CIFInvestor.Position;
                            $scope.OPBOTHER.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBOTHER.business = $scope.CIFInvestor.NatureOfBusiness;
                            $scope.OPBOTHER.businessText = $scope.CIFInvestor.NatureOfBusinessText;
                        }
                    }


                    if (data.data.d.SpouseNationality) {

                        if (data.data.d.SpouseNationality == 102) {

                            $scope.IDLength = 16;
                            $scope.chkSpouseSeumurHidup = true;
                            $scope.DisabledSeumurHidup = true;
                            $scope.CIFInvestor.SpouseNationality = 102;
                            $scope.SpouseKewarganegaraan = $scope.SpouseKewarganegaraanOption[0];
                            $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(9998, 11, 31);
                        } else {

                            $scope.IDLength = 8;
                            $scope.chkSpouseSeumurHidup = false;
                            $scope.DisabledSeumurHidup = true;
                            $scope.SpouseKewarganegaraan = $scope.SpouseKewarganegaraanOption[1];
                            $scope.SpouseNationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.SpouseNationality }, true)[0];

                            if (data.data.d.SpouseIDCardExpiredDate)
                                $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(data.data.d.SpouseIDCardExpiredDate);
                        }
                    } else {
                        $scope.SpouseKewarganegaraanChange();
                    }

                    if ($scope.CIFInvestor.SpouseCompanyCity == 0)
                        $scope.CIFInvestor.SpouseCompanyCity = '';

                    if ($scope.CIFInvestor.CompanyCity == 0)
                        $scope.CIFInvestor.CompanyCity = '';

                    if ($scope.CIFInvestor.QuestionNPWP == 0)
                        $scope.CIFInvestor.QuestionNPWP = '';

                    if ($scope.CIFInvestor.FundSource) {

                        $scope.selectedFundSource = [];
                        let temp = $scope.CIFInvestor.FundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSource.push(Number(temp[i]));
                        }
                    }
                    if ($scope.CIFInvestor.SpouseFundSource) {

                        $scope.selectedSpouseFundSource = [];
                        let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedSpouseFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource) {

                        $scope.selectedFundSourceBO = [];
                        let temp = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSourceBO.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseOccupation == 0)
                        $scope.CIFInvestor.SpouseOccupation = '';

                    if ($scope.CIFInvestor.SpouseIncomePerAnnum == 0)
                        $scope.CIFInvestor.SpouseIncomePerAnnum = '';

                    if (data.data.d.CIFInvestorBeneficiaryOwnerBirthDate)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerBirthDate = new Date(data.data.d.CIFInvestorBeneficiaryOwnerBirthDate);


                    $scope.changeSpouseMandatory();
                    $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                    $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                    $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                    $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;


                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation == 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = '';
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution == 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution = '';

                } 
            }
        })
    });

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: 'service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {

                    if (data.data.d.result && $scope.spouseMandatory) {
                        Swal.close();
                        $window.location.href = "#/cif/data-benef";
                    }
                    else if (data.data.d.result && !$scope.spouseMandatory) {
                        Swal.close();
                        $window.location.href = "#/cif/data-pendukung";
                    }
                    else {
                        Swal.fire('Failed', data.data.d.response, 'error');
                    }
                }, function (error) {
                    Swal.fire('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }
}]);